<script setup lang="ts">
import BillPurserLogo from "@/assets/images/branding/bill-purser/logo.svg";
import BillPurserLogoDark from "@/assets/images/branding/bill-purser/logo-dark.svg";
import SimpleKeiriLogo from "@/assets/images/branding/simple-keiri/logo.svg";
import SimpleKeiriLogoDark from "@/assets/images/branding/simple-keiri/logo-dark.svg";
import { useUiTheme } from "@/layout/use-ui-theme.vue";

const uiTheme = useUiTheme();
const props = defineProps<{
  class?: string;
}>();

const TitleLogo = {
  "prod": BillPurserLogo,
  "stg": BillPurserLogo,
  "dev": BillPurserLogo,
  "simple-keiri": SimpleKeiriLogo,
}[MODE];
const TitleLogoDark = {
  "prod": BillPurserLogoDark,
  "stg": BillPurserLogoDark,
  "dev": BillPurserLogoDark,
  "simple-keiri": SimpleKeiriLogoDark,
}[MODE];
</script>
<template>
  <img v-if="uiTheme.currentTheme.value === 'light'" :src="TitleLogo" :class="props.class" />
  <img v-if="uiTheme.currentTheme.value === 'dark'" :src="TitleLogoDark" :class="props.class" />
</template>
